import { FC, useState } from "react"
import { CreateBusinessCardModal } from "../create-business-card-modal"

interface CreateBusinessCardProps {
    onCreate: () => void
}

export const CreateBusinessCard: FC<CreateBusinessCardProps> = ({ onCreate }) => {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            <button onClick={() => setIsOpen(true)} className="filter_button !w-fit">
                Добавить карту
            </button>
            <CreateBusinessCardModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                onCreate={() => {
                    onCreate()
                    setIsOpen(false)
                }}
            />
        </>
    )
}

